// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.full-height[data-v-7c2a957b] {\n  position: relative;\n  height: 100%;\n}\n.el-dialog__body[data-v-7c2a957b] {\n  padding-top: 0px;\n}\n[data-v-7c2a957b] :disabled {\n  color: blue !important;\n}\n[data-v-7c2a957b] .marqee {\n  top: -81px;\n}\n", ""]);
// Exports
module.exports = exports;
